export default __webpack_public_path__ + "static/media/Picture14.2cc47f4f.png";